import * as React from "react";
const SvgArrowUpSmall20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 7,
        fill: "black",
        viewBox: "0 0 10 7"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m8 6.414-3-3-3 3L.586 5 5 .586 9.414 5 8 6.414Z",
      clipRule: "evenodd"
    })
  );
export default SvgArrowUpSmall20Px;
